/* PricingTiers.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"],
  _excluded13 = ["as", "style"],
  _excluded14 = ["as", "style"],
  _excluded15 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _41 = "._y3gnusic{text-align:right}";
const _40 = "._1x821ts4{font-variant-numeric:tabular-nums}";
const _39 = "._n3td1b66{padding-bottom:var(--ds-space-050,4px)}";
const _38 = "._ca0q1b66{padding-top:var(--ds-space-050,4px)}";
const _37 = "._vwz4gktf{line-height:20px}";
const _36 = "._1wybdlk8{font-size:14px}";
const _35 = "._1wyb1tcg{font-size:24px}";
const _34 = "._k48pni7l{font-weight:600}";
const _33 = "._vwz41ul9{line-height:30px}";
const _32 = "._otyr1wug{margin-bottom:auto}";
const _31 = "._19pk1wug{margin-top:auto}";
const _30 = "._1yt4l6l0{padding:var(--ds-space-300)}";
const _29 = "._4cvr1h6o{align-items:center}";
const _28 = "._y3gn1e5h{text-align:left}";
const _27 = "._1yt4zu5n{padding:var(--ds-space-200,1pc) 0}";
const _26 = "._1wybljao{font-size:var(--ds-font-size-200,1rem)}";
const _25 = "._n7zl7v06{border-bottom:1px solid var(--ds-border)}";
const _24 = "._y3gn1h6o{text-align:center}";
const _23 = "@media not all and (min-width:64rem){._1tvskb7n{flex-grow:1}._1bzwkb7n{flex-shrink:1}._1a8l1wug{flex-basis:auto}._8fz6hhrg{max-width:11rem}}";
const _22 = "._1ul91w81{min-width:150px}";
const _21 = "._1dyznl7k{letter-spacing:.3px}";
const _20 = "._2lx2vrvc{flex-direction:row}";
const _19 = "._19it7v06{border:1px solid var(--ds-border)}";
const _18 = "._2hwxh461{margin-right:var(--ds-space-050)}";
const _17 = "._1n261g80{flex-wrap:wrap}";
const _16 = "._qtt8glyw{list-style:none}";
const _15 = "._19bvidpf{padding-left:0}";
const _14 = "._n3tdidpf{padding-bottom:0}";
const _13 = "._u5f3idpf{padding-right:0}";
const _12 = "._ca0qidpf{padding-top:0}";
const _11 = "._18u0idpf{margin-left:0}";
const _10 = "._2hwxidpf{margin-right:0}";
const _9 = "._18u01wug{margin-left:auto}";
const _8 = "._otyridpf{margin-bottom:0}";
const _7 = "._2hwx1wug{margin-right:auto}";
const _6 = "._19pkidpf{margin-top:0}";
const _5 = "._p12f1ris{max-width:max-content}";
const _4 = "._2lx21bp4{flex-direction:column}";
const _3 = "._1bah1h6o{justify-content:center}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { GridUtils } from '@atlassian/amkt-common';
import { Skeleton } from '@atlassian/mpac-ui';
import { AdditionalPricingSection } from '../PricingTab.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._otyrpb5x{margin-bottom:var(--_1s1re0b)}";
export const PricingDescription = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1s1re0b": ix(GridUtils.GutterSpacing.Comfortable)
      }),
      ref: __cmplr,
      className: ax(["_otyrpb5x", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingDescription.displayName = 'PricingDescription';
}
export const PricingTiersContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1h6o _2lx21bp4 _p12f1ris _19pkidpf _2hwx1wug _otyridpf _18u01wug", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTiersContainer.displayName = 'PricingTiersContainer';
}
export const PricingTierList = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "dl",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _10, _8, _11, _12, _13, _14, _15, _16, _2, _3, _17, _, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1s1re0b": ix(GridUtils.GutterSpacing.Comfortable)
      }),
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c1txw _1bah1h6o _1n261g80 _otyrpb5x _p12f1ris", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierList.displayName = 'PricingTierList';
}
export const FooterTiersLabel = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2hwxh461", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FooterTiersLabel.displayName = 'FooterTiersLabel';
}
export const AdditionalPricingSectionWithBorder = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = AdditionalPricingSection,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19it7v06 _2lx2vrvc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AdditionalPricingSectionWithBorder.displayName = 'AdditionalPricingSectionWithBorder';
}
export const PricingTierListItem = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_21, _19, _2, _4, _22, _5, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1dyznl7k _19it7v06 _1e0c1txw _2lx21bp4 _1ul91w81 _p12f1ris _1tvskb7n _1bzwkb7n _1a8l1wug _8fz6hhrg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierListItem.displayName = 'PricingTierListItem';
}
export const PricingTierGridItemHeader = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "dt",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _10, _8, _11, _24, _25, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _n7zl7v06 _1wybljao _1yt4zu5n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierGridItemHeader.displayName = 'PricingTierGridItemHeader';
}
export const PricingTierListItemHeader = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _10, _8, _11, _28, _26, _27]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1e5h _1wybljao _1yt4zu5n", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierListItemHeader.displayName = 'PricingTierListItemHeader';
}
export const PricingTierListItemContent = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "dd",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _29, _4, _30, _31, _7, _32, _9, _33]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _1yt4l6l0 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _vwz41ul9", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierListItemContent.displayName = 'PricingTierListItemContent';
}
export const PricingTierAmount = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_34, _35]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48pni7l _1wyb1tcg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierAmount.displayName = 'PricingTierAmount';
}
export const PricingTierRecurrence = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_36, _37]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wybdlk8 _vwz4gktf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierRecurrence.displayName = 'PricingTierRecurrence';
}
export const PricingTierRowSkeleton = Skeleton.Row;
export const PricingTierTableCell = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_38, _39, _40]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0q1b66 _n3td1b66 _1x821ts4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierTableCell.displayName = 'PricingTierTableCell';
}
export const PricingTierTableAmountCell = forwardRef((_ref13, __cmplr) => {
  let {
      as: C = PricingTierTableCell,
      style: __cmpls
    } = _ref13,
    __cmplp = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_41]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gnusic", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PricingTierTableAmountCell.displayName = 'PricingTierTableAmountCell';
}
export const RemoteAgentTierItemHeader = forwardRef((_ref14, __cmplr) => {
  let {
      as: C = PricingTierListItemHeader,
      style: __cmpls
    } = _ref14,
    __cmplp = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RemoteAgentTierItemHeader.displayName = 'RemoteAgentTierItemHeader';
}
export const RemoteAgentTierItemUnitText = forwardRef((_ref15, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref15,
    __cmplp = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _10, _8, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RemoteAgentTierItemUnitText.displayName = 'RemoteAgentTierItemUnitText';
}